<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-09 15:44:00
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-23 15:43:50
 * @name: 主页
 * @Description: 主页
 * @FilePath: \project\src\views\index\index.vue
 * @Author: desktop
-->
<template>
  <div class="index">
    <index-router-link :indexView="indexView"></index-router-link>
    <div class="container">
      <div class="content">
        <index-head :indexView="indexView"></index-head>
        <index-main :indexView="indexView"></index-main>
      </div>
    </div>
  </div>
</template>
<script>
import indexView from "./index.view";
import indexRouterLink from "@/components/index/index-router-link.vue";
import indexHead from "@/components/index/index-head.vue";
import indexMain from "@/components/index/index-main.vue";
import { getEventBus } from "@/config/eventBus.config.js";
export default {
  name: "index",
  components: {
    indexRouterLink,
    indexHead,
    indexMain,
  },
  data() {
    return {
      indexView: {},
    };
  },
  watch: {
    $route: {
      handler(nv, ov) {
        this.$nextTick(() => {
          this.indexView.setTitle(nv);
          this.indexView.indexRouterLinkActive = nv.matched[1].path;
        });
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.indexView = new indexView(this);
    this.indexView.getUserInfo();
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.index {
  width: 100%;
  height: 100%;
  min-width: 1100px;
  @extend .et-flex-normal;
  flex-wrap: nowrap;
  .container {
    flex: 1;
    height: 100%;
    overflow-x: auto;
    .content {
      width: 100%;
      height: 100%;
      @extend .et-flex-column-normal;
    }
  }
}
</style>